import React from 'react/addons';
import Immutable from 'immutable';
import pad from 'pad';
import rebound from 'rebound';
import cx from 'classnames';

import Icon from '../common/Icon';

import CarouselItem from './CarouselItem';


React.initializeTouchEvents(true);

function stopPropagation(event) {
  event.stopPropagation();
}

/*
 * The following 3 functions are stolen from an example, but seem to work?
 */
function progressForValueInRange(value, startValue, endValue) {
  return (value - startValue) / (endValue - startValue);
}

function transitionForProgressInRange(progress, startValue, endValue) {
  return startValue + (progress * (endValue - startValue));
}

function transitionForProgressInSteps(progress, numChildren) {
  var transition = -1;
  var steps = Immutable.Range(0, numChildren).toJS();
  var normalizedProgress;
  
  // Bail if there's fewer than two steps
  if (steps.length < 2) { return transition };
  
  // If the progress is before the beginning of the range, extrapolate from the first and second steps.
  if (progress < 0) {
    transition = transitionForProgressInRange(progress, steps[0], steps[1]);
  }

  // If the progress is after the end of the range, extrapolate from the second last and last steps.
  else if (progress > (steps.length - 1)) {
    normalizedProgress = progressForValueInRange(progress, Math.floor(progress), Math.floor(progress) + 1);
    normalizedProgress = normalizedProgress + 1;
    transition = transitionForProgressInRange(normalizedProgress, steps[(steps.length - 2)], steps[(steps.length - 1)]);
  }
  
  // Supress potential NaNs
  else if (progress === (steps.length - 1) || progress === 0) {
    transition = steps[progress];
  }
  
  // Otherwise interpolate between steps
  else {
    normalizedProgress = progressForValueInRange(progress, Math.floor(progress), Math.floor(progress) + 1);
    transition = transitionForProgressInRange(normalizedProgress, steps[Math.floor(progress)], steps[Math.floor(progress) + 1]);
  }

  return transition;
}


var Carousel = React.createClass({
  getInitialState() {
    return {
      offsetX: 0,
      currentIndex: 0,
      endValue: 0,
      handleX: 0,
      handleXOrigin: null
    };
  },

  componentDidMount() {
    var springSystem = new rebound.SpringSystem();
    var spring = springSystem.createSpring(4.5, 5.7);
    var timer;

    spring.setCurrentValue(this.state.currentIndex);
    spring.setEndValue(this.state.currentIndex);
    spring.setAtRest();

    spring.addListener({
      onSpringUpdate: (spring) => {
        var progress = spring.getCurrentValue();
        var x = transitionForProgressInSteps(progress, this.props.children.length);

        this.setState({offsetX: x})
      }
    });

    if (this.props.autoplay) {
      timer = setTimeout(this.transitionForwards, this.props.autoplay);
    }

    this.spring = spring;
    this.timer = timer;
  },

  componentWillUnmount() {
    if (this.props.autoplay) {
      clearTimeout(this.timer);
    }
  },

  transitionBackwards() {
    var numChildren = this.props.children.length;
    var nextIndex = this.state.currentIndex - 1;

    if (nextIndex < 0) {
      nextIndex = numChildren - 1;
    }

    if (this.spring.isAtRest()) {
      this.spring.setCurrentValue(this.state.currentIndex);
    }    

    this.setIndex(nextIndex);
  },

  transitionForwards() {
    var numChildren = this.props.children.length;
    var nextIndex = this.state.currentIndex + 1;

    if (nextIndex >= numChildren) {
      nextIndex = 0;
    }

    if (this.spring.isAtRest()) {
      this.spring.setCurrentValue(this.state.currentIndex);
    }

    this.setIndex(nextIndex);
  },

  onProgressBarClick(event) {
    var handleSize = 100 / this.props.children.length;
    var el;
    var rect;
    var x;
    var handleLeft;
    var nextIndex;

    el = this.refs.progress.getDOMNode();
    rect = el.getBoundingClientRect();

    x = event.pageX - rect.left;

    handleLeft = (100 * x) / rect.width;

    nextIndex = Math.floor(handleLeft / handleSize);

    if (this.spring.isAtRest()) {
      this.spring.setCurrentValue(this.state.currentIndex);
    }

    this.setIndex(nextIndex);
  },

  startDragging(x) {
    this.spring.setAtRest();
    this.setState({
      lastX: x,
      isDragging: true
    });
  },

  continueDragging(x, width, rubberBand) {
    var panVelocity = x - this.state.lastX;
    var lastX = x;

    var progress = progressForValueInRange(panVelocity, 0, -width);
    var currentValue = this.spring.getCurrentValue();

    var minValue = 0;
    var maxValue = this.props.children.length - 1;
    var nextValue = currentValue + progress;

    if (rubberBand) {
      // Rubberband when beyond the scroll boundaries
      if (nextValue < minValue) {
        progress *= 0.5;
      } else if (nextValue > maxValue) {
        progress *= 0.5;
      }
    }
   
    this.spring.setCurrentValue(currentValue + progress);
    this.spring.setAtRest();

    this.setState({panVelocity, lastX});
  },

  endDragging(width) {
    var currentPosition = this.spring.getCurrentValue();
    var restPosition = this.state.currentIndex;
    
    var passedVelocityTolerance = (Math.abs(this.state.panVelocity) > 3);
    var passedDistanceTolerance = Math.abs(currentPosition - restPosition) > 0.3;
    var shouldAdvance = passedDistanceTolerance || passedVelocityTolerance;
    var advanceForward = (this.state.panVelocity <= 0);
    
    if (shouldAdvance) {
      var targetIndex = advanceForward ? restPosition + 1 : restPosition - 1;
      this.setIndex(targetIndex, true);
    } else {
      this.setIndex(restPosition, true);       
    }
    
    var normalizedVelocity = progressForValueInRange(this.state.panVelocity, 0, -width);

    this.spring.setVelocity(normalizedVelocity * 30);

    this.setState({
      isDragging: false,
      panVelocity: 0
    });
  },

  springMouseDown(event) {
    this.startDragging(event.clientX);
    document.addEventListener('mousemove', this.springMouseMove);
    document.addEventListener('mouseup', this.springMouseUp);
  },

  springTouchStart(event) {
    var touch = event.touches[0];
    this.startDragging(touch.clientX);

    document.addEventListener('touchmove', this.springTouchMove);
    document.addEventListener('touchend', this.springTouchEnd);    
    document.addEventListener('touchcancel', this.springTouchEnd);
  },

  springMouseMove(event) {
    var width = this.refs.wrapper.getDOMNode().getBoundingClientRect().width;

    if (this.state.isDragging) {
      this.continueDragging(event.clientX, width, true);
    }
  },

  springTouchMove(event) {
    var width = this.refs.wrapper.getDOMNode().getBoundingClientRect().width;
    var touch = event.touches[0];
    this.continueDragging(touch.clientX, width, true);
  },

  springMouseUp(event) {
    var width = this.refs.wrapper.getDOMNode().getBoundingClientRect().width;

    this.endDragging(width);
    document.removeEventListener('mousemove', this.springMouseMove);
    document.removeEventListener('mouseup', this.springMouseUp);    
  },

  springTouchEnd(event) {
    var width = this.refs.wrapper.getDOMNode().getBoundingClientRect().width;

    this.endDragging(width);
    document.removeEventListener('touchmove', this.springTouchMove);
    document.removeEventListener('touchend', this.springTouchEnd);
    document.removeEventListener('touchcancel', this.springTouchEnd);    
  },

  onHandleMoveStart(eventX) {
    var bar = this.refs.progress.getDOMNode();
    var {width: barWidth, left: barLeft} = bar.getBoundingClientRect();

    var handle = this.refs.handle.getDOMNode();
    var {width: handleWidth, left: handleLeft} = handle.getBoundingClientRect();

    var offsetX = eventX - barLeft;
    var handleOffsetX = eventX - handleLeft;

    var proportion = (offsetX - handleOffsetX) / barWidth;

    this.spring.setCurrentValue(this.state.currentIndex);
    this.startDragging(-proportion);

    this.setState({
      dragHandleOffset: handleOffsetX
    });
  },

  onHandleMoveContinue(eventX) {
    var {children} = this.props;

    var bar = this.refs.progress.getDOMNode()
    var {width: barWidth, left: barLeft} = bar.getBoundingClientRect();

    var offsetX = eventX - barLeft;
    var proportion = (offsetX - this.state.dragHandleOffset) / barWidth;

    var handleSize = 100 / this.props.children.length;
    var rect = this.refs.progress.getDOMNode().getBoundingClientRect();

    var x = eventX - rect.left;

    var handleLeft = (((100 * x) / rect.width) / handleSize) - ((handleSize / 2) / handleSize);

    if (handleLeft < 0) {
      handleLeft = 0;
    } else if (handleLeft > children.length - 1) {
      handleLeft = children.length - 1;
    }

    this.setState({handleX: handleLeft});

    var maxPropotion = (children.length - 1) / children.length;

    if (proportion > maxPropotion) {
      proportion = maxPropotion;
    } else if (proportion < 0) {
      proportion = 0;
    }

    this.continueDragging(-proportion, 1 / children.length, false);
  },

  onHandleMoveEnd() {
    var nextIndex = Math.round(this.state.handleX);

    if (this.state.panVelocity > 0) {
      nextIndex = Math.ceil(nextIndex);
    } else {
      nextIndex = Math.floor(nextIndex);
    }

    this.spring.setEndValue(nextIndex);

    this.setState({
      isDragging: false,
      currentIndex: nextIndex,
      panVelocity: 0
    });
  },

  onHandleMouseDown(event) {
    this.onHandleMoveStart(event.clientX);
    document.addEventListener('mousemove', this.onHandleMouseMove);
    document.addEventListener('mouseup', this.onHandleMouseUp);
  },

  onHandleMouseMove(event) {
    this.onHandleMoveContinue(event.clientX);
  },

  onHandleMouseUp(event) {
    this.onHandleMoveEnd();
    document.removeEventListener('mousemove', this.onHandleMouseMove);
    document.removeEventListener('mouseup', this.onHandleMouseUp);      
  },    

  onHandleTouchStart(event) {
    var touch = event.touches[0];
    this.onHandleMoveStart(touch.clientX);
    document.addEventListener('touchmove', this.onHandleTouchMove);
    document.addEventListener('touchend', this.onHandleTouchEnd);
    document.addEventListener('touchcancel', this.onHandleTouchEnd);
  },    

  onHandleTouchMove(event) {
    var touch = event.touches[0];
    this.onHandleMoveContinue(touch.clientX);
  },

  onHandleTouchEnd(event) {
    this.onHandleMoveEnd();
    document.removeEventListener('touchmove', this.onHandleTouchMove);
    document.removeEventListener('touchend', this.onHandleTouchEnd);      
    document.removeEventListener('touchcancel', this.onHandleTouchEnd);
  },    

  setIndex(index) {
    if (index < 0) {
      index = 0;  
    } else if (index > this.props.children.length - 1) {
      index = this.props.children.length - 1;  
    }
    this.spring.setEndValue(index);
    this.setState({currentIndex: index, handleX: index});
  },

  render() {
    var {children, noOverflow, ratio} = this.props;
    var {offsetX, handleX} = this.state;
    var numChildren = children.length;
    var index;
    var peekSize = 2;

    var childrenWindow = Immutable.Range(-peekSize, numChildren + peekSize).map(function(i) {
      var j = i;
      if (i < 0) {
        j = numChildren + i;
      } else if (i >= numChildren) {
        j = i - numChildren;
      }
      return children[j];
    });

    var items = childrenWindow.map((c, i) => <CarouselItem baseOffset={101 * i -(101 * peekSize)}>{c}</CarouselItem>);
    var numDigits = numChildren.toString().length;

    var handleScale = 100 / numChildren;

    index = Math.floor(handleX);

    var itemsStyle = {
      left: `${101 * -offsetX}%`
    };

    var handleStyles = {
      width: `${handleScale}%`,
      left: `${handleScale * handleX}%`
    };

    var wrapperClasses = {
      'ofs-Carousel__ItemsWrapper': true,
      'ofs-Carousel__ItemsWrapper--no-overflow': noOverflow
    };

    var paddingBottom = (100 / ratio) + '%';

    return (
      <div className="ofs-Carousel">
        <div className="ofs-Carousel__Inner">
          <div 
            className={cx(wrapperClasses)} 
            style={{paddingBottom}} 
            ref="wrapper"
            onMouseDown={this.springMouseDown}
            onTouchStart={this.springTouchStart}            
            >
            <ul 
              className="ofs-Carousel__Items" 
              ref="items" 
              style={itemsStyle} 
              >
              {items.toJS()}
            </ul>
            {this.state.currentIndex > 0 && <div className="ofs-Carousel__Arrow ofs-Carousel__Arrow--previous" 
              onMouseDown={stopPropagation}
              onTouchStart={stopPropagation}
              onClick={this.transitionBackwards}>
              <Icon glyph="arrow" variant="left" size="medium" />
            </div>}
            {this.state.currentIndex < numChildren - 1 && <div className="ofs-Carousel__Arrow ofs-Carousel__Arrow--next" 
              onMouseDown={stopPropagation}
              onTouchStart={stopPropagation}
              onClick={this.transitionForwards}>
              <Icon glyph="arrow" variant="right" size="medium" />
            </div>}
          </div>
          <div className="ofs-Carousel__Footer">
            <div className="ofs-Carousel__ProgressBar" onClick={this.onProgressBarClick} ref="progress">
              <div className="ofs-Carousel__ProgressLine" />
              <div className="ofs-Carousel__ProgressHandleWrapper"
                style={handleStyles}
                onMouseDown={this.onHandleMouseDown}
                onTouchStart={this.onHandleTouchStart}
                >
                <div className="ofs-Carousel__ProgressHandle" ref="handle"  />
              </div>
            </div>
            <div className="ofs-Carousel__Counter">{pad(numDigits, index + 1, '0')}/{numChildren}</div>
          </div>
        </div>
      </div>
    );
  }
});


export default Carousel;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/carousel/Carousel.jsx
 **/